// Copyright (c) Bentley Systems, Incorporated. All rights reserved.
import * as amplitude from "@amplitude/analytics-browser"

import readEnv from "~/src/readEnv"

const amplitudeConfig = readEnv("amplitude") || {}

const { apiKey, userId } = amplitudeConfig

// Initialize Amplitude
if (apiKey) {
  amplitude.init(apiKey, userId, {
    defaultTracking: {
      sessions: true,
      pageViews: true,
      formInteractions: true,
      fileDownloads: true,
      elementInteractions: true,
      frustrationInteractions: true,
    },
  })
}

export default amplitude
